<template>
  <div
    class="bg-white border border-emerald-100 rounded-2xl flex flex-col md:flex-row h-full overflow-hidden transition-all duration-300 group hover:shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:scale-[1.02] hover:-translate-y-1"
  >
    <!-- Image Section (Right side on desktop) -->
    <div
      class="w-full hidden md:flex md:w-2/5 items-center justify-center order-1 md:order-2"
    >
      <img
        v-if="insight.imageUrl"
        :src="insight.imageUrl"
        :alt="insight.imageAlt || insight.title"
        class="w-full h-full object-contain p-4 md:p-6 max-w-[280px]"
      />
    </div>

    <!-- Text Content Section -->
    <div class="w-full md:w-3/5 p-6 md:p-8 flex flex-col order-2 md:order-1">
      <!-- Mobile Header with Side-by-Side Layout -->
      <div class="md:hidden flex flex-row items-start gap-4 mb-6">
        <div class="w-1/2 flex flex-col">
          <div v-if="insight.iconSvg" class="mb-4">
            <img :src="insight.iconSvg" :alt="insight.title" class="w-8 h-8" />
          </div>
          <h3 class="text-lg font-heading font-bold text-gray-800 uppercase">
            {{ insight.title }}
          </h3>
        </div>
        <div class="w-1/2">
          <img
            v-if="insight.imageUrl"
            :src="insight.imageUrl"
            :alt="insight.imageAlt || insight.title"
            class="w-full h-full object-contain"
          />
        </div>
      </div>

      <!-- Desktop Header -->
      <div class="hidden md:block">
        <div v-if="insight.iconSvg" class="mb-6">
          <img :src="insight.iconSvg" :alt="insight.title" class="w-10 h-10" />
        </div>
        <h3
          class="text-xl lg:text-2xl font-heading font-bold text-gray-800 uppercase mb-4"
        >
          {{ insight.title }}
        </h3>
      </div>

      <p class="text-gray-600 text-sm sm:text-base leading-relaxed flex-grow">
        {{ insight.description }}
      </p>

      <div v-if="insight.linkText && insight.linkUrl" class="pt-4 md:pt-5">
        <a
          :href="insight.linkUrl"
          class="text-emerald-500 font-semibold hover:text-emerald-600 text-sm group relative"
        >
          {{ insight.linkText }}
          <span
            class="inline-block transition-transform group-hover:translate-x-1"
            >&rarr;</span
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  insight: {
    type: Object,
    required: true,
    default: () => ({
      iconSvg: "",
      title: "",
      description: "",
      linkText: null,
      linkUrl: null,
      imageUrl: null,
      imageAlt: null,
    }),
  },
});
</script>
